const floatCTA = document.getElementById("floatCTA");
window.addEventListener("scroll", () => {
  if (window.scrollY > 500) {
    floatCTA.classList.remove(
      "opacity-0",
      "pointer-events-none",
      "translate-y-4",
    );
    floatCTA.classList.add("opacity-100", "translate-y-0");
  } else {
    floatCTA.classList.add("opacity-0", "pointer-events-none", "translate-y-4");
    floatCTA.classList.remove("opacity-100", "translate-y-0");
  }
});
let notifQ = [1, 2, 3],
  notifIdx = 0,
  notifTimer;

function showNotif(id) {
  document.getElementById(`notif${id}`).classList.remove("hidden");
  notifTimer = setTimeout(() => closeNotif(id), 5000);
}

function closeNotif(id) {
  document.getElementById(`notif${id}`).classList.add("hidden");
  clearTimeout(notifTimer);
  setTimeout(
    () => {
      notifIdx = (notifIdx + 1) % notifQ.length;
      showNotif(notifQ[notifIdx]);
    },
    30000 + Math.random() * 25000,
  );
}
setTimeout(() => showNotif(notifQ[0]), 32000);
let gIdx = 0;
const gTrack = document.getElementById("galleryTrack");
const gDots = document.querySelectorAll(".gallery-dot");
const gImgs = document.querySelectorAll(".gallery-img");
const totalSlides =
  typeof wp_total_images !== "undefined" && wp_total_images > 0
    ? wp_total_images
    : window.product_data?.images?.length || gImgs.length;

function updateGallery() {
  gTrack.style.transform = `translateX(-${gIdx * 100}%)`;
  gDots.forEach(
    (d, i) => (d.style.background = i === gIdx ? "#0D9488" : "#D6D3D1"),
  );
}

function galleryNext() {
  gIdx = (gIdx + 1) % totalSlides;
  updateGallery();
}

function galleryPrev() {
  gIdx = (gIdx - 1 + totalSlides) % totalSlides;
  updateGallery();
}

function galleryGo(i) {
  gIdx = i;
  updateGallery();
}
let touchStartX = 0;
const slider = document.getElementById("galleryS");
slider.addEventListener(
  "touchstart",
  (e) => (touchStartX = e.touches[0].clientX),
  {
    passive: true,
  },
);
slider.addEventListener(
  "touchend",
  (e) => {
    const diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) diff > 0 ? galleryNext() : galleryPrev();
  },
  {
    passive: true,
  },
);
const lightbox = document.getElementById("lightbox");
const lbImg = document.getElementById("lightboxImg");
const lbCounter = document.getElementById("lightboxCounter");
const lbDots = document.querySelectorAll(".lb-dot");
let lbIdx = 0;

function updateLightbox() {
  lbImg.src = gImgs[lbIdx].src;
  lbCounter.textContent = `${lbIdx + 1} / ${totalSlides}`;
  lbDots.forEach(
    (d, i) =>
      (d.style.background = i === lbIdx ? "#0D9488" : "rgba(255,255,255,0.3)"),
  );
}

function openLightbox(i) {
  lbIdx = i;
  updateLightbox();
  lightbox.classList.remove("hidden");
  document.body.style.overflow = "hidden";
}

function closeLightbox() {
  lightbox.classList.add("hidden");
  document.body.style.overflow = "";
}

function lightboxNext() {
  lbIdx = (lbIdx + 1) % totalSlides;
  updateLightbox();
}

function lightboxPrev() {
  lbIdx = (lbIdx - 1 + totalSlides) % totalSlides;
  updateLightbox();
}

function lightboxGo(i) {
  lbIdx = i;
  updateLightbox();
}
lightbox.addEventListener("click", (e) => {
  if (e.target === lightbox) closeLightbox();
});
document.addEventListener("keydown", (e) => {
  if (lightbox.classList.contains("hidden")) return;
  if (e.key === "Escape") closeLightbox();
  if (e.key === "ArrowRight") lightboxNext();
  if (e.key === "ArrowLeft") lightboxPrev();
});
let lbTouchX = 0,
  lbTouchY = 0;
lightbox.addEventListener(
  "touchstart",
  (e) => {
    lbTouchX = e.touches[0].clientX;
    lbTouchY = e.touches[0].clientY;
  },
  {
    passive: true,
  },
);
lightbox.addEventListener(
  "touchend",
  (e) => {
    const dx = lbTouchX - e.changedTouches[0].clientX;
    const dy = lbTouchY - e.changedTouches[0].clientY;
    if (Math.abs(dy) > 80 && Math.abs(dy) > Math.abs(dx)) closeLightbox();
    else if (Math.abs(dx) > 50) dx > 0 ? lightboxNext() : lightboxPrev();
  },
  {
    passive: true,
  },
);
const reviewSlider = document.getElementById("reviewSlider");
const rsImg = document.getElementById("reviewSliderImg");
const rsCounter = document.getElementById("reviewSliderCounter");
const rsUser = document.getElementById("reviewSliderUser");
const rsStars = document.getElementById("reviewSliderStars");
const reviewImgs = document.querySelectorAll(".review-img");
let rsIdx = 0;
const rsTotal = reviewImgs.length;

function updateReviewSlider() {
  const img = reviewImgs[rsIdx];
  rsImg.src = img.src;
  rsCounter.textContent = `${rsIdx + 1} / ${rsTotal}`;
  rsUser.textContent = img.dataset.user;
  const rating = parseInt(img.dataset.rating);
  rsStars.innerHTML = "";
  for (let i = 0; i < 5; i++) {
    const star = document.createElement("i");
    star.className =
      i < rating ? "fas fa-star text-xs" : "fa-regular fa-star text-xs";
    star.style.color = "#0D9488";
    rsStars.appendChild(star);
  }
}

function openReviewSlider(i) {
  rsIdx = i;
  updateReviewSlider();
  reviewSlider.classList.remove("hidden");
  document.body.style.overflow = "hidden";
}

function closeReviewSlider() {
  reviewSlider.classList.add("hidden");
  document.body.style.overflow = "";
}

function reviewSliderNext() {
  rsIdx = (rsIdx + 1) % rsTotal;
  updateReviewSlider();
}

function reviewSliderPrev() {
  rsIdx = (rsIdx - 1 + rsTotal) % rsTotal;
  updateReviewSlider();
}
reviewSlider.addEventListener("click", (e) => {
  if (e.target === reviewSlider) closeReviewSlider();
});
document.addEventListener("keydown", (e) => {
  if (reviewSlider.classList.contains("hidden")) return;
  if (e.key === "Escape") closeReviewSlider();
  if (e.key === "ArrowRight") reviewSliderNext();
  if (e.key === "ArrowLeft") reviewSliderPrev();
});
let rsTouchX = 0,
  rsTouchY = 0;
reviewSlider.addEventListener(
  "touchstart",
  (e) => {
    rsTouchX = e.touches[0].clientX;
    rsTouchY = e.touches[0].clientY;
  },
  {
    passive: true,
  },
);
reviewSlider.addEventListener(
  "touchend",
  (e) => {
    const dx = rsTouchX - e.changedTouches[0].clientX;
    const dy = rsTouchY - e.changedTouches[0].clientY;
    if (Math.abs(dy) > 80 && Math.abs(dy) > Math.abs(dx)) closeReviewSlider();
    else if (Math.abs(dx) > 50)
      dx > 0 ? reviewSliderNext() : reviewSliderPrev();
  },
  {
    passive: true,
  },
);

function toggleFaq(btn) {
  const item = btn.parentElement;
  const content = item.querySelector(".faq-content");
  const icon = item.querySelector(".faq-icon i");
  const allItems = document.querySelectorAll(".faq-item");
  allItems.forEach((i) => {
    if (i !== item) {
      i.querySelector(".faq-content").classList.add("hidden");
      i.querySelector(".faq-icon i").classList.replace("fa-minus", "fa-plus");
      i.querySelector(".faq-icon").style.background = "#F0FDFA";
    }
  });
  content.classList.toggle("hidden");
  if (content.classList.contains("hidden")) {
    icon.classList.replace("fa-minus", "fa-plus");
    item.querySelector(".faq-icon").style.background = "#F0FDFA";
  } else {
    icon.classList.replace("fa-plus", "fa-minus");
    item.querySelector(".faq-icon").style.background = "#0D9488";
    icon.style.color = "#FFFFFF";
  }
}

document.addEventListener('variant:change', (event) => {
  const priceContainer = document.getElementById('price-product-template-data');
  if (!priceContainer) return;

  const variant = event.detail.variant;
  const productUrl = window.location.pathname;

  fetch(`${productUrl}?variant=${variant.id}&section_id=product-template-data`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const newPrice = html.querySelector('#price-product-template-data');

      if (newPrice) {
        priceContainer.innerHTML = newPrice.innerHTML;
      }
    })
    .catch((error) => console.error('Error updating price:', error));
});
